import { Box } from "@mui/material";

const sx = {
  style: {
    display: "flex",
    position: "absolute",
    fontWeight: "600",
    fontSize: "157.72px",
    transform: "rotate(-30deg)",
    zIndex: "100",
    color: "#000000",
    opacity: "0.05",
    top: "130px",
    left: "10%"
  }
};

const IllustrativeImage = ({ display, title }) => {
  return <Box position="relative">{display ? <Box sx={sx.style}>{title}</Box> : null}</Box>;
};
export default IllustrativeImage;
